'use client';

import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="sq">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', backgroundColor: '#090d16', color: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '1rem' }}>
        <div style={{ maxWidth: '480px', width: '100%', textAlign: 'center', padding: '2rem', backgroundColor: '#0f172a', borderRadius: '1.5rem', border: '1px solid #1e293b', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5)' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '1rem', backgroundColor: '#38bdf820', color: '#38bdf8', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem auto', fontSize: '2rem' }}>
            ⚠️
          </div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: '0.5rem' }}>
            Ndodhi një gabim në ngarkimin e sistemit
          </h1>
          <p style={{ fontSize: '0.875rem', color: '#94a3b8', lineHeight: 1.5, marginBottom: '1.5rem' }}>
            Platforma DYRMA Climate hasi një problem të papritur. Ju lutem provoni ta rifreskoni faqen.
          </p>
          <button
            onClick={() => reset()}
            style={{ padding: '0.75rem 1.5rem', borderRadius: '0.75rem', backgroundColor: '#0284c7', color: '#ffffff', fontWeight: 'bold', fontSize: '0.875rem', border: 'none', cursor: 'pointer', transition: 'background-color 0.2s' }}
          >
            Rifresko Sistemin
          </button>
        </div>
      </body>
    </html>
  );
}
